export default function ctaOffer () {

	const toggles = document.querySelectorAll('section.cta-offer .view-more:not([data-initialised])');

	if (! toggles.length) return;

	toggles.forEach(function (toggle) {

		toggle.setAttribute('data-initialised', '');

		toggle.addEventListener('click', function () {

			const targetId = toggle.getAttribute('aria-controls');
			const target = targetId ? document.getElementById(targetId) : null;

			toggle.setAttribute('aria-expanded', 'true');
			if (target) target.classList.add('is-open');

		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=cta-offer', ctaOffer);
}
